import { render, staticRenderFns } from "./store-card.vue?vue&type=template&id=6f5c9b4a&"
import script from "./store-card.vue?vue&type=script&lang=js&"
export * from "./store-card.vue?vue&type=script&lang=js&"
import style0 from "./store-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f5c9b4a')) {
      api.createRecord('6f5c9b4a', component.options)
    } else {
      api.reload('6f5c9b4a', component.options)
    }
    module.hot.accept("./store-card.vue?vue&type=template&id=6f5c9b4a&", function () {
      api.rerender('6f5c9b4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/stores/store-card.vue"
export default component.exports